<template>
<div class="ts-app-shell_fh">
    <div class="padd-main job-details-body">
        <div class="ts-app-shell--header">
            <h5>
                <strong>View Role</strong>
            </h5>            
            <div class="ts-app-shell--header_actions indv-button" style="right: 0; padding-right: 290px;position: absolute;">
                <el-button @click="backToRoleMatches">Back to Role Matches</el-button>   
            </div>
            <div class="ts-app-shell--header_actions indv-button" style="right: 0; padding-right: 150px;position: absolute;">
                <el-button class="btn-dark" @click="applyForRole">Apply for Role</el-button>      
            </div>
            <div class="ts-app-shell--header_actions indv-button" style="right: 0; padding-right: 60px;position: absolute;">
                <el-button class="btn-details-secondary" @click="exportJobDetails">Export</el-button>   
            </div>
            <div class="mobile-menu" style="display: none; right: 0; padding-right: 30px;position: absolute;">
                <el-dropdown  trigger="click" style="display:none;">
                <i class="fas fa-ellipsis-v" style="font-size: 24px; margin-left: 20px;"></i>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item class="el-dropdown-menu__item" ><span @click="backToRoleMatches">Back to Role Matches</span></el-dropdown-item>
                    <el-dropdown-item class="el-dropdown-menu__item" ><span @click="applyForRole">Apply for Role </span></el-dropdown-item>
                    <el-dropdown-item class="el-dropdown-menu__item" ><span @click="exportJobDetails">Export </span></el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>  
            </div>      
        </div>

        <el-divider></el-divider>

        <RolePostingDetails v-if="showComponent"
            :VacantRoleInfo="vacantInfo"/>        

    </div>

    <div class="job-details-print" style="display:none">
        <PrintRolePostingDetails v-if="showComponent"
            :VacantRoleInfo="vacantInfo"/> 
    </div>
</div>
</template>

<script>

import RolePostingDetails from '../../../components/workflow/RolePostingDetails.vue';
import PrintRolePostingDetails from '../../../components/workflow/PrintRolePostingDetails.vue';

export default {
    components : {
        RolePostingDetails,
        PrintRolePostingDetails
    },
    methods: {
        backToRoleMatches() {
            // this.$router.push({ name: "role-matching" });
            this.$router.go(-1);
        },
        applyForRole() {
            this.$router.push({ name: 'ConfirmApplyForRoleDialog', params: { data: this.match }});
        },
        defaultDocument() {
            const main = document.getElementsByClassName('job-details-body')[0];
            if (main) {
                main.style.display = 'block';
            }

            const sub = document.getElementsByClassName('job-details-print')[0];
            if (sub) {
                sub.style.display = 'none' ;
                sub.style.marginLeft = '0px'
            }

            const menu = document.getElementsByClassName('el-menu-vertical-demo')[0];
            if (menu) {
                menu.style.display = 'block';
            }
        },
        exportJobDetails(){
            const main = document.getElementsByClassName('job-details-body')[0];
            if (main) {
                main.style.display = 'none';
            }

            const sub = document.getElementsByClassName('job-details-print')[0];
            if (sub) {
                sub.style.display = 'block';
                sub.style.marginLeft = '-250px'
            }

            const menu = document.getElementsByClassName('el-menu-vertical-demo')[0];
            if (menu) {
                menu.style.display = 'none';
            }
            
            window.print();
            this.defaultDocument();            
        }
    },
    beforeDestroy() {
        if(this.$router.history.current.name != 'search-jobs'){
            sessionStorage.setItem('searchResultsSession', null)
        }
    },
    data() {
        return {
            showComponent: false,
            companybranding: null,
            vacantInfo: {},
            match: {}
        }
    },
    created() {
        var vacantId = this.$route.params.vacantid;
        this.match = this.$route.params.matchdetail;

        this.$store.dispatch('jobseeker/getRoleInfo', vacantId)
          .then((res) => {
            this.vacantInfo = res;
            this.showComponent = true;
          }); 

        this.defaultDocument();
    },
    
}
</script>

<style>
.btn-dark {
  background-color: #14223c;
  color: white;
}

@media screen and (max-width: 759px) {
    .indv-button{
        display: none !important;
    }

    .mobile-menu{
        display: unset !important;
    }
}
</style>